var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"10",
      dataClass:2,
      name:"权限角色授权(按权限)",
      parentId:"TEAM_ID",
      parentName:"权限角色设置",
      parentPath:"/system/userGroup",
      addForm:{
        TEAM_ID:_vm.$route.query.TEAM_ID,
      },
      addClick: _vm.addClick
    }}}),_c('wx-select',{ref:"wxSelect",attrs:{"visible":_vm.selector,"select":{
      searchslottitle: "请选择用户",
      searchslotId: 100,
      searchslotkey: { ID: "USER_ID", $ID: "USER_NAME" },
      multiple: true,
      loadObj: {
        filterWhere: _vm.$route.query.TEAM_ID,
        colname: "ROLE_TEAM",
      },
    }},on:{"update:visible":function($event){_vm.selector=$event},"return":_vm.fn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }